$( document ).on("turbo:load", function(){

  if ($('.features-form').length > 0) {
    var sectionGroups = $('#section_groups'),
        userAccounts = $('#user_accounts');

    userAccountsDisplaying();

    userAccounts.on('change', function() {
      userAccountsDisplaying();
    });

    function userAccountsDisplaying() {
      if (userAccounts.is(':checked')) {
        sectionGroups.parent().show();
      }
      else {
        sectionGroups.prop('checked', false);
        sectionGroups.parent().hide();
      }
    }
  }

});
